'use strict'

export default {
  BREAKPOINT: 768,
  SCROLL_OFFSET_LG: -50,
  SCROLL_OFFSET_SM: -80,
  SCROLL_DURATION_LG: 900,
  SCROLL_DURATION_SM: 1200,
  SCROLL_EASING_LG: 'easeInOutQuart',
  SCROLL_EASING_SM: 'easeInOutQuart'
}
